export default __webpack_public_path__ + "img/cfXDIsml.55d36513.svg";